import add from '../assets/lernsets/icons/add.svg';
import addCollection from '../assets/lernsets/icons/add-collection.svg';
import alleTab from '../assets/lernsets/icons/alleTab.svg';
import alleTabBold from '../assets/lernsets/icons/alleTab-Bold.svg';
import arrowDropdownFilled from '../assets/lernsets/icons/arrow-dropdown-filled.svg';
import arrowDown from '../assets/lernsets/icons/arrow-down.svg';
import arrowUp from '../assets/lernsets/icons/arrow-up.svg';
import arrowUpRightLong from '../assets/lernsets/icons/arrow-up-right-long.svg';
import arrowRight from '../assets/lernsets/icons/arrow-right.svg';
import arrowLeft from '../assets/lernsets/icons/arrow-left.svg';
import attachments from '../assets/course/attachments.svg';
import book from '../assets/lernsets/icons/book.svg';
import bookmark from '../assets/lernsets/icons/bookmark.svg';
import bookmarkAdded from '../assets/lernsets/icons/bookmark-added.svg';
import calendar from '../assets/lernsets/icons/calendar.svg';
import check from '../assets/course/check.svg';
import checkbox from '../assets/lernsets/icons/checkbox.svg';
import clipboardText from '../assets/lernsets/icons/clipboard-text.svg';
import close from '../assets/close.svg';
import clock from '../assets/course/clock.svg';
import cog from '../assets/lernsets/icons/cog.svg';
import docText from '../assets/doc-text.svg';
import download from '../assets/lernsets/icons/download.svg';
import dropdownOpenSmall from '../assets/dropdownOpenSmall.svg';
import dropdownClosedSmall from '../assets/dropdownClosedSmall.svg';
import copy from '../assets/lernsets/icons/copy.svg';
import feather from '../assets/lernsets/icons/feather.svg';
import folderAdd from '../assets/lernsets/icons/folder-add.svg';
import folderAddPurple from '../assets/lernsets/icons/folder-add-purple.svg';
import folderRemove from '../assets/lernsets/icons/folder-remove.svg';
import folderRemovePurple from '../assets/lernsets/icons/folder-remove-purple.svg';
import heart from '../assets/course/heart.svg';
import importIcon from '../assets/course/import.svg';
import invalidLink from '../assets/lernsets/icons/invalid-url.svg';
import mindItemTab from '../assets/lernsets/icons/mindItemTab.svg';
import mindItemTabBold from '../assets/lernsets/icons/mindItemTab-Bold.svg';
import notes from '../assets/lernsets/icons/notes.svg';
import paperclip from '../assets/lernsets/icons/paperclip.svg';
import pause from '../assets/course/pause.svg';
import play from '../assets/lernsets/icons/play.svg';
import playOutlined from '../assets/course/play-outlined.svg';
import printer from '../assets/lernsets/icons/printer.svg';
import productTab from '../assets/lernsets/icons/productTab.svg';
import productTabBold from '../assets/lernsets/icons/productTab-Bold.svg';
import redTrash from '../assets/lernsets/icons/redTrash.svg';
import selectedCheckbox from '../assets/lernsets/icons/selectedCheckbox.svg';
import search from '../assets/search.svg';
import searchDone from '../assets/search-done.svg';
import searchStatus from '../assets/search-status.svg';
import share from '../assets/share.svg';
import sort from '../assets/lernsets/icons/sort.svg';
import star from '../assets/lernsets/icons/star.svg';
import starBold from '../assets/lernsets/icons/boldStar.svg';
import starFilled from '../assets/lernsets/icons/star-filled.svg';
import starFilledPurple from '../assets/lernsets/icons/star-filled-purple.svg';
import starPurple from '../assets/lernsets/icons/star-purple.svg';
import tag from '../assets/lernsets/icons/tag.svg';
import teacher from '../assets/lernsets/icons/teacher.svg';
import trash from '../assets/lernsets/icons/trash.svg';
import userTesting from '../assets/lernsets/icons/user-testing.svg';
import videoTab from '../assets/lernsets/icons/videoTab.svg';
import videoTabBold from '../assets/lernsets/icons/videoTab-Bold.svg';
import zeroResultsMobile from '../assets/lernsets/icons/zero-results-mobile.svg';
import zeroResultsTablet from '../assets/lernsets/icons/zero-results-tablet.svg';
import home from '../assets/sideNav/home.svg';
import searchNormal from '../assets/sideNav/search-normal.svg';
import downloads from '../assets/sideNav/downloads.svg';
import clipboard from '../assets/sideNav/clipboard.svg';
import teacherNav from '../assets/sideNav/teacher.svg';
import folderFavourite from '../assets/sideNav/folder-favourite.svg';
import medal from '../assets/sideNav/medal.svg';
import message from '../assets/sideNav/message.svg';
import messageQuestion from '../assets/sideNav/message-question.svg';
import arrowUpOutline from '../assets/sideNav/arrow-up-outline.svg';
import arrowUpLong from '../assets/lernsets/icons/arrow-up-long.svg';
import muLogoBag from '../assets/sideNav/mu-logo-bag.svg';
import muLogo from '../assets/MuLogo.svg';
import paragraph from '../assets/sideNav/paragraph.svg';
import save from '../assets/sideNav/save.svg';
import hamburger from '../assets/hamburger.svg';
import profileCircle from '../assets/sideNav/profile-circle.svg';
import cards from '../assets/sideNav/cards.svg';
import logout from '../assets/sideNav/logout.svg';
import muLogoFull from '../assets/sideNav/mu-logo-full.svg';
import arrowLeftTooltip from '../assets/sideNav/arrow-left.svg';
import user from '../assets/lernsets/icons/user.svg';
import courseSuccess from '../assets/course/course-successfull.svg';
import courseProgress from '../assets/course/course-inprogress.svg';
import arrowDropUp from '../assets/sideNav/arrow-drop-up.svg';
import arrowDropDown from '../assets/sideNav/arrow-drop-down.svg';
import progressTab from '../assets/course/progress-tab.svg';
import progressTabBold from '../assets/course/progress-tab-bold.svg';
import successTab from '../assets/course/success-tab.svg';
import successTabBold from '../assets/course/success-tab-bold.svg';
import checkVerify from '../assets/check-verify.svg';
import checkOutlineVerify from '../assets/check-outline-verify.svg';
import magicPen from '../assets/lernsets/icons/magicpen.svg';
import maximize from '../assets/assistant/maximize.svg';
import minimize from '../assets/assistant/minimize.svg';

const icons = {
  add,
  addCollection,
  alleTab,
  alleTabBold,
  arrowDown,
  arrowDropdownFilled,
  arrowLeft,
  arrowUp,
  arrowUpRightLong,
  arrowUpLong,
  arrowRight,
  attachments,
  book,
  bookmark,
  bookmarkAdded,
  search,
  calendar,
  check,
  checkVerify,
  checkOutlineVerify,
  checkbox,
  clipboardText,
  clock,
  close,
  cog,
  copy,
  docText,
  download,
  dropdownOpenSmall,
  dropdownClosedSmall,
  feather,
  folderAdd,
  folderAddPurple,
  folderRemove,
  folderRemovePurple,
  heart,
  invalidLink,
  mindItemTab,
  mindItemTabBold,
  notes,
  paperclip,
  pause,
  play,
  playOutlined,
  printer,
  productTab,
  productTabBold,
  redTrash,
  searchDone,
  searchStatus,
  selectedCheckbox,
  share,
  sort,
  star,
  starBold,
  starFilled,
  starFilledPurple,
  starPurple,
  tag,
  teacher,
  trash,
  userTesting,
  videoTab,
  videoTabBold,
  zeroResultsMobile,
  zeroResultsTablet,
  home,
  searchNormal,
  downloads,
  clipboard,
  teacherNav,
  folderFavourite,
  medal,
  message,
  messageQuestion,
  arrowUpOutline,
  muLogoBag,
  muLogo,
  paragraph,
  save,
  hamburger,
  profileCircle,
  cards,
  logout,
  muLogoFull,
  arrowLeftTooltip,
  user,
  importIcon,
  courseSuccess,
  courseProgress,
  arrowDropUp,
  arrowDropDown,
  progressTab,
  progressTabBold,
  successTab,
  successTabBold,
  magicPen,
  maximize,
  minimize
};

export type IconName = keyof typeof icons;

const getMuiIcon = (icon: IconName) => icons[icon];

export default getMuiIcon;

